"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var ReactEasyForm_1 = require("../ReactEasyForm");
var ErrorText_1 = __importDefault(require("../helpers/ErrorText"));
var react_hook_form_1 = require("react-hook-form");
var useStyles = core_1.makeStyles({
    label: {
        height: "100%",
        width: "100%",
    },
});
function RadioButton(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var classes = useStyles();
    var form = react_1.useContext(ReactEasyForm_1.FormContext);
    if (!form) {
        throw new Error("form is not defined");
    }
    var minButtonWidth = (_a = props.minButtonWidth) !== null && _a !== void 0 ? _a : "100%";
    // const numberOfColumns = props.numberOfColumns ?? 1;
    var columnGap = (_b = props.gridColumnGap) !== null && _b !== void 0 ? _b : 0;
    var rowGap = (_c = props.gridRowGap) !== null && _c !== void 0 ? _c : 0;
    var muiRadioGroupStyle = (_e = (_d = props.muiRadioGroupProps) === null || _d === void 0 ? void 0 : _d.style) !== null && _e !== void 0 ? _e : {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(" + minButtonWidth + ",1fr))",
        gridAutoRows: "1fr",
        gridColumnGap: columnGap.toString() + "px",
        gridRowGap: rowGap.toString() + "px",
    };
    var muiButtonProps = (_f = props.muiButtonProps) !== null && _f !== void 0 ? _f : {
        color: "primary",
        variant: "outlined",
    };
    var muiButtonActiveProps = props.muiButtonActiveProps
        ? __assign({}, props.muiButtonActiveProps) : __assign(__assign({}, muiButtonProps), { variant: "contained" });
    var muiRadioProps = (_g = props.muiRadioProps) !== null && _g !== void 0 ? _g : {
        color: "default",
    };
    var muiRadioActiveProps = props.muiRadioActiveProps
        ? __assign({}, props.muiRadioActiveProps) : __assign({}, muiRadioProps);
    var errorActive = false;
    var errorText = undefined;
    if (form.errors[props.name] !== undefined) {
        errorActive = true;
        errorText = form.errors[props.name].message;
    }
    var possibleValues = props.options.map(function (option) {
        return option.value;
    });
    if (props.defaultValue) {
        if (!possibleValues.includes(props.defaultValue)) {
            throw new Error("the default value \"" + props.defaultValue + "\" is not found in the possible values specified in the options \"" + JSON.stringify(possibleValues) + "\"");
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hook_form_1.Controller, { name: props.name, control: form.control, defaultValue: (_h = props.defaultValue) !== null && _h !== void 0 ? _h : "", rules: props.rules, render: function (_a) {
                var _b;
                var onChange = _a.onChange;
                return (react_1.default.createElement(core_1.RadioGroup, __assign({ "aria-label": props.name, style: muiRadioGroupStyle }, props.muiRadioGroupProps, { defaultValue: (_b = props.defaultValue) !== null && _b !== void 0 ? _b : "" }), props.options.map(function (option) {
                    var buttonProps = form.getValues(props.name) === option.value ? muiButtonActiveProps : muiButtonProps;
                    var radioProps = form.getValues(props.name) === option.value ? muiRadioActiveProps : muiRadioProps;
                    return (react_1.default.createElement(core_1.Button, __assign({ classes: { label: classes.label } }, buttonProps, { style: __assign({ padding: "0px", textTransform: "none", textAlign: "left" }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.style), key: option.value.toString() + "button" }),
                        react_1.default.createElement(core_1.FormControlLabel, __assign({ value: option.value, label: option.label, key: option.value, control: react_1.default.createElement(core_1.Radio, __assign({ onChange: function () { return onChange(option.value); } }, radioProps)), labelPlacement: "start" }, props.muiFormControlLabelProps, { style: {
                                width: "100%",
                                height: "100%",
                                padding: "6px 16px",
                                margin: "0px",
                                display: "flex",
                                justifyContent: "space-between",
                            } }))));
                })));
            } }),
        react_1.default.createElement(ErrorText_1.default, { active: errorActive, text: errorText })));
}
exports.default = RadioButton;
